//load bootstrap scripts (from node modules folder)
import 'bootstrap';

//load custom scripts
import './scripts/initialise.js';
import './scripts/nav.js';
import './scripts/gsap.js';